import axios from "axios";

export function insertOrderLimits(accountId, data, type) {
  console.log("accountId: ", accountId)
  var config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/order-limits`,
    data: data
  };
  return axios(config);
}

export function createPrinter(accountId, shop, data, type) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/printers`,
      params: shop,
      data
  }
  return axios(config);
}

export function invoiceSwitch(accountId, data, type) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/invoice-switch`,
      data
  }
  return axios(config);
}

export function createInvoice(accountId, data, type) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/invoice`,
      data
  }
  return axios(config);
}

export function fetchInvoices(accountId, data) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/fetch-invoices`,
    data
  }
  return axios(config);
}

export function createPosmw(accountId, data, type) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/mw-settings`,
    data
  }
  return axios(config);
}

export function enableService(accountId, service, data, type) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/services/${service}`,
    data
  }
  return axios(config);
}

export function addActiveVendor(accountId, vendor_code, type) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/mw-setting-active`,
    data: { vendor_code }
  }
  return axios(config);
}

export function createAppKeys(accountId,  type) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${accountId}/app-keys`
  }
  return axios(config);
}
